import {additionalEmailAPI, maxChatAPI, telegramChatAPI, webhookAPI} from 'entities/notification';
import {locationAPI} from 'entities/location';
import {paymentAPI} from 'entities/payment';
import {promoCodeAPI, tariffAPI} from 'entities/tariff';
import {userAPI} from 'entities/user';

import {summaryHomeAPI, tagsAPI} from 'entities/monitor';

import {cityAPI, countryAPI, incidentStatsAPI, metricsAPI, tariffVariantAPI, zoneAPI} from 'features/admin';
import {domainMonitorAPI, domainIncidentAPI} from 'features/domain';
import {httpIncidentAPI, httpMonitorAPI} from 'features/http';
import {portIncidentAPI, portMonitorAPI} from 'features/port';
import {userReportAPI} from 'features/userReports';
import {serverAPI, serverAlertRuleAPI, serverIncidentAPI} from 'features/server';
import {statusPageAPI} from 'features/statusPage';
import {supportAPI} from 'features/support';

export const apis = [
    additionalEmailAPI,
    cityAPI,
    countryAPI,
    domainMonitorAPI,
    httpIncidentAPI,
    incidentStatsAPI,
    locationAPI,
    maxChatAPI,
    metricsAPI,
    httpMonitorAPI,
    paymentAPI,
    portIncidentAPI,
    portMonitorAPI,
    promoCodeAPI,
    userReportAPI,
    serverAPI,
    serverAlertRuleAPI,
    serverIncidentAPI,
    statusPageAPI,
    summaryHomeAPI,
    supportAPI,
    tagsAPI,
    tariffAPI,
    tariffVariantAPI,
    telegramChatAPI,
    userAPI,
    domainIncidentAPI,
    webhookAPI,
    zoneAPI,
] as const;

type Api = typeof apis[number];

export type ApiReducers = {
    [A in Api as A['reducerPath']]: A['reducer'];
};

export const apiReducers = Object.fromEntries(
    apis.map(api => [api.reducerPath, api.reducer]),
) as ApiReducers;
